import actions from "./actions";

const initState = {
  grades: null,
  subjects: null,
  gradesAutoComplete: null,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_GRADES_SUCCESS:
      return {
        ...state,
        grades: action.grades,
      };
    case actions.FETCH_GRADE_SUBJECT_SUCCESS:
      return {
        ...state,
        subjects: action.subjects,
      };
    case actions.FETCH_GRADES_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        gradesAutoComplete: action.grades,
      };
    case actions.RESET:
      return {
        ...state,
        grades: null,
        subjects: null,
      };
    default:
      return state;
  }
}
